/**
 * Debounce time we use to wait for user keystrokes to finish before submitting a query
 *
 * May want to vary this depending on the intensity of the action we are debouncing, but this is our "usual case"
 * for searches
 */
export const DEBOUNCE_TIME_FOR_KEYSTROKE_IN_MS = 300;
